import React, { useEffect, useState } from "react";
import closeIcon from "../../../../../../assets/close_small.svg";
import { Box, Button, Text, TextInput, Layer, TextArea } from "grommet";
import "./Sidebar.css";
import medical from "../../../../../../assets/medical_services.svg";
import CommonButton from "../../../common/Button/CommonButton";
import searchIcon from "../../../../../../assets/search.svg";
import MedicalEmergencyService from "../../../../../../services/medical-emergency/medical-emergency.service";
import closeCross from "../../../../../../assets/close_small (2).svg";
import { useParams } from "react-router-dom";
import { useStore } from "../../../../../../Hooks/useStore";
import { sendDataToTopic } from "../../../../../../App";
import { Autoupdateenum } from "../../../../../../enums";
import MedicalKitPagination from "../../../common/Pagination/MedicalKitPagination/MedicalKitPagination";
import { observer } from "mobx-react";

const Sidebar = observer(({ isOpen, closeSidebar }) => {  
  const [selectedItems, setSelectedItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [comments, setComments] = useState({});
  const [itemPerPage, setItemPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchTerm, setSearchTerm] = useState("");
  const { medicalEmergencyId } = useParams();
  const { rootStore } = useStore();

  const handlePageChange = (page)=> {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (isOpen && medicalEmergencyId !== undefined) {
      getCreateKit(medicalEmergencyId, rootStore.emsStore.getMedicalKitId);
    }
  }, [isOpen, rootStore.emsStore.getupdate, rootStore.emsStore.getMedicalKitRefresh]);

  useEffect(() => {
    filterItems();
  }, [rootStore.emsStore.getKitSelectedItem, searchTerm]);

  const getCreateKit = async (mId, kitId) => {
    try {
      const ItemData = await MedicalEmergencyService.getSideKit(mId, kitId);
      rootStore.emsStore.handleKitSelectedItem(ItemData);
      if (ItemData == "") {
        rootStore.errorStore.errorNotification("msg", "error", 3000);
      }
      const initialComments = ItemData.reduce((acc, item) => {
        acc[item.itemId] = "";
        return acc;
      }, {});
      setComments(initialComments);
    } catch (error) {
      console.error("Error fetching medical kits:", error);
    }
  };

  const filterItems = () => {
    const newArr = [...rootStore.emsStore.getKitSelectedItem];
    const filtered = newArr.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    rootStore.emsStore.handleKitItem(filtered);
  };

  const handleSearch = () => {
    filterItems();
  };

  const handleUseButtonClick = (item) => {
    setSelectedItemId(item.itemId);
    setSelectedItem(item);
  };

  const closePopup = () => {
    setSelectedItem(null);
  };

  const onCommentChange = (event) => {
    setComments((prevComments) => ({
      ...prevComments,
      [selectedItemId]: event.target.value,
    }));
  };

  const onEditSubmit = async () => {
    try {
      if (medicalEmergencyId !== undefined && selectedItemId !== null) {
        const comment = comments[selectedItemId];
        let response = await MedicalEmergencyService.getAdd(
          comment,
          rootStore.emsStore.getMedicalKitId,
          medicalEmergencyId,
          selectedItemId
        );
        sendDataToTopic(
          rootStore.emsStore.getSelectedEmergency?.id,
          rootStore.emsStore.getSelectedEmergency?.flightId,
          Autoupdateenum.MedicalKit
        );
        console.log("Edit kit item response", response);
      }
      rootStore.emsStore.handleupdate();
    } catch (error) {
      console.log("Edit kit item error", error);
    }
    closePopup();
  };

  const onRemove = async (id) => {
    try {
      if (medicalEmergencyId !== undefined && id !== null) {
        let response = await MedicalEmergencyService.removeData(
          rootStore.emsStore.getMedicalKitId,
          medicalEmergencyId,
          id
        );
        console.log("Remove kit item response", response);
        sendDataToTopic(
          rootStore.emsStore.getSelectedEmergency?.id,
          rootStore.emsStore.getSelectedEmergency?.flightId,
          Autoupdateenum.MedicalKit
        );
      }
    } catch (error) {
      console.log("Remove kit item error", error);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  if (!isOpen) return null;

  const startIndex = (currentPage - 1) * itemPerPage;
  const endIndex = startIndex + itemPerPage;
  const visibleUsersList = rootStore.emsStore.getKitItem.slice(startIndex, endIndex);

  return (
    <Box className="sidebar-container">
      <Box className="side">
        <Box className="side-content">
          <Box className="header">
            <Box className="left-header">
              <img src={medical} alt="Medical Kit Icon" />
              <Text className="title">Medical Kit Content</Text>
            </Box>
            <Button onClick={closeSidebar} className="close-sidebar-btn">
              <img
                src={closeIcon}
                alt="close sidebar"
                style={{ height: 20, width: 20 }}
              />
              Close
            </Button>
          </Box>

          <Box className="MedicalKit-container">
            <div className="search">
              <div className="search-input">
                <TextInput
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <img src={searchIcon} className="icon" alt="Search" />
              </div>
              <CommonButton
                title="Search"
                padding="12px 24px 12px 28px"
                color="#fff"
                bgColor="#357EFF"
                radius={10}
                border="1px solid #357EFF"
                lineheight="14px"
                ml={10}
                onClick={handleSearch}
              />
            </div>
            <ul className="items-container">
              {visibleUsersList.map((item, index) => (
                <li key={item.id} style={{backgroundColor: item.description ? "#EEF1F6" : "#F2F7FF"}}>
                  <div className="kit-items-container">
                    <div className="left-content">
                      <div className="top-line">
                        <div>{(currentPage - 1) * itemPerPage + (index + 1)}. </div>
                        <div style={{marginLeft: 5}}>{item.name}</div>
                      </div>
                    </div>
                    <div className="right-content">
                        {item.description ? (
                          <button
                            className="use"
                            onClick={() => onRemove(item.itemId)}
                          >
                            Remove
                          </button>
                        ) : (
                          <button
                            className="use"
                            onClick={() => handleUseButtonClick(item)}
                          >
                            Use
                          </button>
                        )}
                    </div>
                  </div>
                  <div className="desc" style={{marginTop: item.description ? 12 : 0}}>{item.description}</div>
                </li>
              ))}
            </ul>

          {Math.ceil(rootStore.emsStore.getKitSelectedItem.length / itemPerPage) > 1 && (
            <MedicalKitPagination
              currentPage={currentPage}
              totalPages={Math.ceil(rootStore.emsStore.getKitSelectedItem.length / itemPerPage)}
              totalItems={rootStore.emsStore.getKitSelectedItem.length}
              onPageChange={handlePageChange}
              totalitemPerpage = {itemPerPage}
            />
          )}
          </Box>
          {selectedItem && (
            <Layer
              position="center"
              modal
              onClickOutside={closePopup}
              onEsc={closePopup}
              style={{
                zIndex: 1000,
                width: "50%",
                position: "absolute",
                display: "inline-flex",
                flexDirection: "column",
                borderRadius: "14px",
                background: "#FFF",
              }}
            >
              <Box
                position={"relative"}
                style={{ padding: "40px 40px 30px 40px" }}
                zIndex={100}
              >
                <Button
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                    padding: 0,
                  }}
                  className="closeCross"
                  icon={<img src={closeCross} alt="Close" />}
                  onClick={closePopup}
                />
                <Box direction="row" align="center" justify="between">
                  <Text
                    style={{
                      alignSelf: "stretch",
                      color: "#4B628A",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "22px",
                      marginBottom: 8,
                    }}
                  >
                    Add Comment
                  </Text>
                </Box>
                <Box>
                  <TextArea
                    placeholder="Enter here"
                    value={comments[selectedItemId] || ""}
                    onChange={onCommentChange}
                    rows={5}
                    fill={true}
                    resize={false}
                    style={{
                      padding: "15px",
                      borderRadius: "10px",
                      background: "#F2F8FF",
                      border: "unset",
                      color: "#A7B6D1",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "300",
                      lineHeight: "22px",
                    }}
                  />
                  <Box direction="row" justify="center" margin={"20px 0 0 0"}>
                    <button className="submit" onClick={onEditSubmit}>
                      Submit
                    </button>
                  </Box>
                </Box>
              </Box>
            </Layer>
          )}
        </Box>
      </Box>
    </Box>
  );
});

export default Sidebar;
